import { assert } from './assert-sidecar'
import { l } from './imports'

export function t(condition: boolean, ...error: any[]): asserts condition {
  if (!condition) {
    let message = 'ERROR assert failed'
    let fullMessage = ''
    for (let i = 0; i < error.length; i++) {
      fullMessage += '|'
      fullMessage += error[i]
    }

    console.error(message, ...error)
    throw new Error(message + fullMessage)
  }
}
export function f(
  condition: boolean,
  ...error: any[]
): asserts condition is false {
  t(!condition, ...error)
}
export function nil(
  item: any,
  ...error: any[]
): asserts item is null | undefined {
  t(item === null || item === undefined, 'nil', ...error)
}
export function notNil(item: any, ...error: any[]): asserts item {
  t(item !== null && item !== undefined, 'notNil', ...error)
}
export function notEmpty(item: any[], ...error: any[]): asserts item {
  t(item != null && item.length > 0, 'notEmpty', ...error)
}
export function notUndefined(item: any, ...error: any[]): asserts item {
  t(item !== undefined, 'notUndefined', ...error)
}
export function notEmptyString(
  item: string | null | undefined,
  ...error: any[]
): asserts item {
  t(
    item != null && item != '' && item.trim().length > 0,
    'notEmptyString',
    ...error,
  )
}
export function inRange(v: number, min: number, max: number, ...error: any[]) {
  assert.t(v >= min && v <= max, 'range error', v, min, max, ...error)
}

export function onlyOneIsNotNil(a: any, b: any, ...error: any[]) {
  f(a == null && b == null, 'both nil', ...error)
  f(a != null && b != null, 'both not nil', ...error)
}

export function notIn(array: any[], item: any, ...error: any[]) {
  t(!l.includes(array, item), 'notIn', ...error)
}

export function isIn(array: any[], item: any, ...error: any[]) {
  t(l.includes(array, item), 'isIn', ...error)
}
export function eq<T>(a: T, b: T, ...error: any[]) {
  t(a === b, 'eq', ...error)
}
export function notEq<T>(a: T, b: T, ...error: any[]) {
  t(a !== b, 'not-eq', ...error)
}
export function failed(...error: any[]) {
  t(false, ...error)
}
export function loopLimit(loopCount: number, max: number, ...error: any[]) {
  if (loopCount > max) {
    t(false, 'loop hit limit', max, ...error)
  }
}
export function shouldNotExecute(...error: any[]): never {
  failed('should not excute', ...error)
  throw new Error('Unreachable code')
}
